var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-box"},[_c('WorkOrders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }